import _ from '../../core/utils'
import API from '../api'
import HINT from '../hint'
import MODAL from '../modal'
import SUBMIT from '../submit'
import API_CASE_POSITION_CONFIG from './config'

class ApiCasePositionClass {
    constructor() {
        this.DOM = {
            form: API_CASE_POSITION_CONFIG.form
        }

        this.endpoint = API_CASE_POSITION_CONFIG.endpoint

        this.init()
    }

    init() {
        console.log( this )
        this.DOM.form ? this._listeners() : null
    }

    _listeners() {
        this.DOM.form.addEventListener( 'submit', this._submit.bind( this ) ) 
    }

    _submit() {
        event.preventDefault()
        let form = event.target

        SUBMIT._startLoading( form )
        API.post( this.endpoint, 
            new FormData( form )
        )
        .then( ( response ) => {
            console.log( response )
            if ( response.data.success ) {
                HINT._show( response.data.message, HINT.status.success )
                this._buttonEditBounce( response )
            } else {
                HINT._show( 'Error', HINT.status.error )
            }
        })
        .catch( ( error ) => {
            HINT._show( 'Error', HINT.status.error )
        })
        .then( () => {
            SUBMIT._endLoading( form )
            MODAL._close()
            HINT._hide()
        })
    }

    _buttonEditBounce( response ) {
        let button =  _.select( '.fl__edit-status--case-position' )
        if ( response.data.case_latitude === '54.284581281962' && response.data.case_longitude === '19.973038331372' ) {
           _.addClass( button, 'fl__edit--bounce' )
        } else {
            _.removeClass( button, 'fl__edit--bounce' )
        }
    }
} 

const API_CASE_POSITION = new ApiCasePositionClass()
export default API_CASE_POSITION